export const defaultTabs = [
  {
    name: "Access Points",
    value: "accessPoints",
    isActive: true
  },
  {
    name: "Switches",
    value: "switches",
    isActive: false
  },
  {
    name: "Routers",
    value: "routers",
    isActive: false
  },
]

export const defaultSupportTableData = {
  accessPoints: [],
  switches: [],
  routers: [],
}